export { default, getStaticProps } from '../src/pages/Collections'
